var render = function render(){var _vm=this,_c=_vm._self._c;return _c('process-item-tmp',{attrs:{"cmp":_vm.cmp,"detail-list":_vm.data.purchase ? [_vm.data.purchase] : [],"all-show-detail":_vm.allShowDetail,"show-type":_vm.showType}},[_c('base-info',{attrs:{"id":"assets","data":_vm.data,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }